



























import { Component, Vue, Prop } from 'vue-property-decorator';
import MobileDiscountTooltip from '@/components/familyPortal/sessionCard/MobileDiscountTooltip.vue';

@Component({
  components: {
    MobileDiscountTooltip,
  }
})

export default class MultiParticipantDiscountBadge extends Vue {
  @Prop({ type: String, required: true }) discountName!: string;
  @Prop({ type: String, required: true }) discountDescription!: string;
  @Prop({ type: String, required: true }) tooltipDescription!: string;
  @Prop({ type: Boolean, required: true }) isMobile!: boolean;
}
